export enum LaptopReplacementStatesEnum {
  EMAIL_NOT_INITIATE = "Email not initiated",
  WAITING_RESPONSE = "Awaiting response from TW’er",
  RESPONSE_CAPTURE = "Response Captured",
  REPLACEMENT_IN_PROGRESS = "Replacement In Progress",
  REPLACEMENT_COMPLETED = "Replacement Completed",
  REPLACEMENT_DATA_EXTENDED = "Replacement date extended",
  NO_RESPONSE = "No Response provided",
  SKIPPED = "Skipped",
}

export enum DeliveryModeEnum {
  BOTH = "both",
  COLLECT_AT_OFFICE = "collect_at_office",
  HOME_DELIVERY = "home_delivery",
}

export enum StringFulBooleanValue {
  TRUE = "true",
  FALSE = "false",
}

export enum OptionValue {
  YES = "yes",
  NO = "no",
}

export enum LaptopRenewalFormPage {
  DELIVERY_INFORMATION = "Delivery Information",
  LAPTOP_BUYBACK = "Laptop Buyback",
}

export enum RequestStatusEnum {
  REQUEST_SUCCESS = "Request Success",
  FAILURE = "Failure",
}

export enum AddressConfirmStatusEnum {
  NOT_INITIATE = "not_initiated",
  INITIATED = "initiated",
  ADDRESS_CONFIRMED = "address_confirmed",
}

export enum DeferReplacementReasonEnum {
  VACATION_OR_EXIT_SOON = "Going on vacation / exit soon",
  PROJECT_END = "Project is coming to an end",
  OTHER = "Other",
}

export const GURGAON_CITY = "Gurgaon";
export const GURUGRAM_CITY = "Gurugram";
export const GERMANY_NAME = "Germany";
